import { render, staticRenderFns } from "./HCPMustCompleteTrainingModalComponent.vue?vue&type=template&id=dd13ab64"
import script from "./HCPMustCompleteTrainingModalComponent.vue?vue&type=script&lang=js"
export * from "./HCPMustCompleteTrainingModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports